import { Actions, ActionTypes, State } from "../types";

export const cliReducer = (state: State, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.LANDING_PAGE: {
      const { account, accountInfo } = action;
      return {
        ...state,
        account,
        accountInfo,
      };
    }
    case ActionTypes.SUBMIT_EMPLOYMENT_INCOME:
    case ActionTypes.SUBMIT_EXPENSES:
    case ActionTypes.SUBMIT_ADDITIONAL_DEBTS:
    case ActionTypes.SUBMIT_PERSONAL_DETAILS:
    case ActionTypes.LOAD_APPLICATION_STATUS:
    case ActionTypes.SUBMIT_NEW_CREDIT_LIMIT: {
      const { type: _, ...payload } = action;
      return {
        ...state,
        ...payload,
      };
    }
    default:
      return state;
  }
};
